import React from 'react';
import { useSelector } from 'react-redux';

export default function useReportSelector() {
  const ReportListData = useSelector((state) => state.Report.list_data) || []; // List data
  const ReportHistoryData = useSelector((state) => state.Report.history_data) || []; // History data

  return { ReportListData, ReportHistoryData };
}
